

export class VnaPbxConfigCreated{
    protected url;

    constructor(url) {
        this.url = url;
    }

    getUrl(): string {
        return this.url;
    }

    setUrl(url: string): void {
        this.url = url
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/model/VnaPbxConfigCreated.ts